import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { Header } from 'src/common/header';
import Picking from 'src/common/picking';

export interface MainAppProps {
  user: string;
  signOut: () => void;
}
export const MainApp: React.FC<MainAppProps> = ({ ...props }) => (
  <div>
    <Header user={props.user} signOut={props.signOut} />
    <Switch>
      <Route path="/picking-zpl" render={() => <Picking printStrategy="zpl" />} />
      <Route path="/" render={() => <Picking printStrategy="server" />} />
    </Switch>
  </div>
);
